__turbopack_context__.v({
  "cell": "dynamictable-module-scss-module__R-FC3G__cell",
  "label": "dynamictable-module-scss-module__R-FC3G__label",
  "row": "dynamictable-module-scss-module__R-FC3G__row",
  "table": "dynamictable-module-scss-module__R-FC3G__table",
});
